import { Button } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

export const InviteUserButton = ({ onClick: handleClick }: { onClick: () => void }) => {
    const { t } = useTranslation();
    return (
        <Button leftSection={<Icon icon="forward_to_inbox" />} onClick={handleClick}>
            {t('inviteUser')}
        </Button>
    );
};
